export const subscribeToTracks = (room, { onVideoTrack, onAudioTrack, onTrackUnsubscribed }) => {
    if (!room || !room.on) return () => { };

    const handleTrackSubscribed = (track) => {
        if (track.kind === "video" && onVideoTrack) onVideoTrack(track);
        else if (track.kind === "audio" && onAudioTrack) onAudioTrack(track);
    };

    const handleTrackUnsubscribed = (track) => {
        if (onTrackUnsubscribed) { onTrackUnsubscribed(track) }
    };

    room.on("trackSubscribed", handleTrackSubscribed);
    room.on("trackUnsubscribed", handleTrackUnsubscribed);

    room.remoteParticipants?.forEach((participant) => {
        participant.trackPublications?.forEach((publication) => {
            if (publication.track && publication.isSubscribed) { handleTrackSubscribed(publication.track) }
        });
    });

    return () => {
        room.off("trackSubscribed", handleTrackSubscribed);
        room.off("trackUnsubscribed", handleTrackUnsubscribed);
    };
};
